export default [{ id: 2, name: 'Deduct' }, { id: 3, name: 'Discount' }];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/mode.js